import React from 'react';
import {useNavigate} from "react-router-dom";
import Moment from 'moment';
import 'moment/locale/ru';

type OrderListItemProps = {
    order: {
        itemsCNT: number;
        discount: number;
        client_type: string,
        created_at: string,
        id: number,
        last_name: string,
        name: string,
        payed_summ: number,
        phone: string,
        second_name: string,
        status: number,
        statuses: any,
        total_summ: number
    }
}
const OrderTR = (props: OrderListItemProps) => {
    const navigate = useNavigate();

    function handleClick(id: number) {
        navigate('/orders/' + id)
    }
    function statusClass(status: any) {
        switch (status) {
            case '0':
            case '1':
            case '2':
            case '3':
            case '4':
            case '5':
            case '7':
            case '8':
            case '9':
                return 'bg-gradient-info'
            case '6':
            case '10':
                return 'bg-gradient-warning'
            case '11':
                return 'bg-gradient-success'
            case '12':
                return 'bg-gradient-danger'
            default:
                return 'bg-gradient-danger'
        }
    }
    function statusName(status: any) {
        switch (status) {
            case '0':
                return 'Сканирование'
            case '1':
                return 'Моделирование колодки'
            case '2':
                return 'Изготовление колодки'
            case '3':
                return 'Конструирование модели'
            case '4':
                return 'Пошив заготовки макета'
            case '5':
                return 'Затяжка макета'
            case '6':
                return 'Примерка макета'
            case '7':
                return 'Заготовка итогового варианта'
            case '8':
                return 'Затяжка'
            case '9':
                return 'Финиш'
            case '10':
                return 'Готов к выдаче'
            case '11':
                return 'Выдан'
            case '12':
                return 'Требует внимания'
        }

        return status
    }

    return (
        <tr style={{cursor: "pointer"}} onClick={() => handleClick(props.order.id)}>
            <td>
                <div className="d-flex px-2 py-1">
                    <div className="d-flex flex-column justify-content-center">
                        <h6 className="mb-0">{props.order.id}</h6>
                        <p className="text-secondary mb-0">{Moment(props.order.created_at).format('D MMMM, H:mm')}</p>
                    </div>
                </div>
            </td>
            <td className="align-middle text-center">
                <span className={"badge " + statusClass(props.order.status)}>{statusName(props.order.status)}</span>
            </td>
            <td>
                <p className="font-weight-bold mb-0">{[props.order.last_name, props.order.name, props.order.second_name].join(' ')} <span className="badge bg-gradient-warning">{props.order.client_type}</span></p>
                <p className="text text-secondary mb-0">{props.order.phone}</p>
            </td>
            <td className="align-middle text-center">
                {props.order.itemsCNT}
            </td>
            <td className="align-middle text-center">
                <span className="text-secondary font-weight-bold">{Intl.NumberFormat("ru").format(props.order.total_summ)}</span>
                <p className="text text-secondary mb-0">{props.order.discount > 0 ? props.order.discount + '%' : ''}</p>
            </td>
        </tr>
    );
};

export default OrderTR;